<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Nuevo distrito</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">

        <!-- Label -->
        <vs-input @blur="district.label = trimString(district.label)" label="Nombre del distrito*"
                  v-model="district.label"
                  class="w-full" name="label"
                  v-validate="'required|min:2|max:100'"/>
        <span class="text-danger text-sm" v-show="errors.has('label')">{{ errors.first('label') }}</span>

        <!-- Price -->
        <vs-input label="Precio (S/.)*" v-model.number="district.price"
                  class="mt-5 w-full" name="price" type="number" step="0.1"
                  v-validate="'required|decimal|min_value:0'"/>
        <span class="text-danger text-sm" v-show="errors.has('price')">{{ errors.first('price') }}</span>

        <!-- Sort order -->
        <vs-input label="Orden*" v-model.number="district.sortOrder"
                  class="mt-5 w-full" name="sortOrder" type="number" step="1"
                  v-validate="'required|decimal|min_value:1'"/>
        <span class="text-danger text-sm" v-show="errors.has('sortOrder')">{{ errors.first('sortOrder') }}</span>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
      <div v-if="progress" style="margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import trimString from '../../mixins/trimString'
import { db, FieldValue } from '@/firebase/firebaseConfig'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    VuePerfectScrollbar
  },
  mixins: [trimString],
  data () {
    return {
      district: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.60
      },
      progress: false
    }
  },
  watch: {
    isSidebarActive (val) {
      if (val) {
        this.initValues()
        this.$validator.reset()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    submitData () {
      this.$validator.validateAll().then(async result => {
        if (result) {
          try {
            this.progress = true
            const newDoc = await db.collection('districts').add({
              label: this.district.label,
              price: this.district.price,
              sortOrder: this.district.sortOrder,
              createdAt: FieldValue.serverTimestamp(),
              state: true
            })
            const obj = {
              id: newDoc.id,
              label: this.district.label,
              price: this.district.price,
              sortOrder: this.district.sortOrder,
              state: true
            }
            await this.$store.dispatch('districts/addDistrict', { district: obj })
            this.$emit('closeSidebar')
            this.$vs.notify({
              color: 'success',
              title: 'Distrito',
              text: 'Distrito creado correctamente.'
            })
          } catch (e) {
            this.$vs.notify({
              color: 'warning',
              title: '¡Oh no!',
              text: 'Hubo un error.'
            })
          } finally {
            this.progress = false
          }
        }
      })
    },
    initValues () {
      const districts = this.$store.state.districts.districts || []
      const maxOrder = districts.reduce((max, d) => Math.max(max, d.sortOrder || 0), 0)
      this.district = { sortOrder: maxOrder + 1 }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
  }
}

.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
